<form [formGroup]="emailQrcodeForm" (ngSubmit)="onSubmit()">
  <mat-dialog-content class="mat-typography">
    <div class="d-flex align-items-center justify-content-between m-b-16">
      <h4 class="f-s-16 f-w-600 m-b-16">{{ 'technicians.send_qr_code' | translate }}</h4>
      <button mat-icon-button mat-dialog-close type="button" class="d-flex justify-content-center" (click)="closeModal()">
        <i-tabler name="x" class="icon-20 d-flex"></i-tabler>
      </button>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <mat-label class="f-w-600 d-block m-b-8">{{ 'technicians.send_qrcode_info' | translate }}</mat-label>

        <mat-form-field appearance="outline" class="w-100 hide-hint m-b-8">
          <mat-chip-grid #chipGrid aria-label="CC Email list">
            @for (email of emailQrcodeForm.get('ccEmails')?.value; track email){
            <mat-chip-row
              (removed)="remove(email)">
              {{ email }}
              <button matChipRemove>
                <mat-icon>cancel</mat-icon>
              </button>
            </mat-chip-row>
            }
          </mat-chip-grid>
          <input matInput
                 placeholder="{{ 'technicians.insert_email' | translate }}"
                 [formControl]="newEmailCtrl"
                 [matChipInputFor]="chipGrid"
                 [matChipInputAddOnBlur]="true"
                 [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                 (matChipInputTokenEnd)="add($event)" />
          <mat-error *ngIf="newEmailCtrl.hasError('email') && (newEmailCtrl.touched || newEmailCtrl.dirty)">
            {{ 'login.invalid_email' | translate }}
          </mat-error>

          <mat-error *ngIf="newEmailCtrl.hasError('invalidEmailFormat') && (newEmailCtrl.touched || newEmailCtrl.dirty)">
            {{ 'email.invalid_cc_format' | translate }}
          </mat-error>
        </mat-form-field>
      </div>
    </div>
  </mat-dialog-content>

  <mat-divider></mat-divider>

  <mat-dialog-actions align="end">
    <button mat-flat-button type="submit" color="primary" [disabled]="emailQrcodeForm.invalid">
      {{ 'login.send' | translate }}
    </button>
    <button mat-flat-button (click)="closeModal()" type="button" class="bg-error text-white" mat-dialog-close>
      {{ 'personal_details.close' | translate }}
    </button>
  </mat-dialog-actions>
</form>